import React from 'react';

const ShimmerLine = ({ width = '100%', height = '12px', borderRadius = '6px', style = {} }) => (
  <div
    className="skeleton-pulse"
    style={{
      width,
      height,
      borderRadius,
      background: 'linear-gradient(90deg, #F1F5F9 0%, #E2E8F0 50%, #F1F5F9 100%)',
      backgroundSize: '200% 100%',
      animation: 'mrShimmerWave 1.6s ease-in-out infinite',
      ...style,
    }}
  />
);

const SinglePostCardShimmer = () => {
  return (
    <div
      className="my-3 py-3 position-relative overflow-hidden"
      style={{
        borderRadius: '24px',
        border: '1px solid #D7E0EA',
        background: 'linear-gradient(180deg, #FFFFFF 0%, #F8FDFF 100%)',
        boxShadow: '0px 8px 30px rgba(0, 186, 218, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.03)',
        width: '100%',
      }}
    >
      {/* Subtle Ambient Glow */}
      <div
        style={{
          position: 'absolute',
          top: '-30px',
          right: '-30px',
          width: '120px',
          height: '120px',
          background: '#00BADA',
          opacity: '0.1',
          filter: 'blur(45px)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }}
      />

      {/* Header Row */}
      <div className="d-flex align-items-center justify-content-between px-3 pb-2">
        <div className="d-flex align-items-center gap-3 flex-grow-1">
          {/* Avatar Skeleton */}
          <div
            className="rounded-circle overflow-hidden flex-shrink-0"
            style={{
              width: '46px',
              height: '46px',
              border: '2px solid #E0F7FA',
              padding: '1.5px',
            }}
          >
            <ShimmerLine width="100%" height="100%" borderRadius="50%" />
          </div>

          {/* User Info Lines */}
          <div className="d-flex flex-column gap-2 flex-grow-1" style={{ maxWidth: '240px' }}>
            <ShimmerLine width="75%" height="14px" borderRadius="6px" />
            <ShimmerLine width="45%" height="10px" borderRadius="4px" />
          </div>
        </div>

        {/* Action / Follow Button Placeholder */}
        <div className="flex-shrink-0">
          <ShimmerLine width="76px" height="28px" borderRadius="999px" />
        </div>
      </div>

      {/* Caption Placeholder */}
      <div className="px-3 py-2 d-flex flex-column gap-2">
        <ShimmerLine width="92%" height="12px" />
        <ShimmerLine width="68%" height="12px" />
      </div>

      {/* Media Box Placeholder */}
      <div className="px-3 py-1">
        <div
          className="w-100 overflow-hidden"
          style={{
            borderRadius: '16px',
            height: '260px',
          }}
        >
          <ShimmerLine width="100%" height="100%" borderRadius="16px" />
        </div>
      </div>

      {/* Footer Likes Row */}
      <div className="d-flex align-items-center justify-content-between px-3 pt-3">
        <div className="d-flex align-items-center gap-2">
          <ShimmerLine width="20px" height="20px" borderRadius="50%" />
          <ShimmerLine width="110px" height="11px" borderRadius="4px" />
        </div>
        <ShimmerLine width="65px" height="11px" borderRadius="4px" />
      </div>

      {/* Bottom Actions Bar */}
      <div
        className="d-flex align-items-center justify-content-between px-3 pt-2 mt-2"
        style={{ borderTop: '1px solid #F1F5F9' }}
      >
        <ShimmerLine width="60px" height="24px" borderRadius="12px" />
        <ShimmerLine width="75px" height="24px" borderRadius="12px" />
        <ShimmerLine width="60px" height="24px" borderRadius="12px" />
        <ShimmerLine width="50px" height="24px" borderRadius="12px" />
      </div>

      <style>{`
        @keyframes mrShimmerWave {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </div>
  );
};

const PostCardShimmer = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <SinglePostCardShimmer key={index} />
      ))}
    </>
  );
};

export default PostCardShimmer;
